import React, {Component} from 'react';
import axios from '../../store/axios-instance';
import {connect} from 'react-redux';

class DownloadRecords extends Component {
    state = {
        recordUrl: '',
    };

    componentDidMount() {
        this.setDownloadRecordUrl();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.liveSession?._id !== this.props.liveSession?._id) {
            this.setDownloadRecordUrl();
        }
    }

    setDownloadRecordUrl = () => {
        const sessionId = this.props.liveSession?._id;
        if (sessionId) {
            this.loadSessionRecords(sessionId).then((records) => {
                // in our Zoom Session case, we will only have 1 session recording
                if (records.length) {
                    const recordUrl = records[0];
                    this.setState({recordUrl: recordUrl});
                }
            });
        }
    };

    loadSessionRecords = async (sessionId) => {
        const result = await axios.get(`/sessions/${sessionId}/records`);
        const records = result.data.recordings.map((r) => r.url);
        return records;
    };

    render() {
        const {recordUrl} = this.state;
        if(recordUrl.length === 0){
            return <span> Processing record, please refresh in a couple of minutes...</span>
        }
        return (
            // <div className={'download-record'}>
            <>
                You can download the recording from {' '}
                <a href={recordUrl} target="_blank" rel="noreferrer">here</a>
            </>
            // </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        liveSession: state.liveSession.liveSession,
    };
};

export default connect(mapStateToProps)(DownloadRecords);
